import cancelSrc from '@corbado/shared-ui/assets/cancel.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const CancelIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, cancelSrc, '--cb-passkey-list-description-text-color');
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'cancel', ...props }));
});
